import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";

import { PrivateRoute } from "../PrivateRoute";

export const AppRouter = ({ routes }) =>
  routes.map(({ path, Component, exact = false, isPrivate = false }) => {
    const RouteComponent = isPrivate ? PrivateRoute : Route;

    return (
      <RouteComponent path={path} key={path} exact={exact}>
        <Component />
      </RouteComponent>
    );
  });

AppRouter.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      Component: PropTypes.node,
      exact: PropTypes.bool,
      isPrivate: PropTypes.bool,
    })
  ),
};
